import { bikoClient } from '@/common/apis/client';
import {
  hasCheraghFacilitiesDisplayData,
  type CheraghFacilitiesPublicData,
} from '@/modules/profile/utils/cheraghFacilitiesProfile';

export type { CheraghFacilitiesPublicData } from '@/modules/profile/utils/cheraghFacilitiesProfile';
export {
  CHERAGH_APP_KEY,
  CHERAGH_WIDGET_ID,
  hasCheraghFacilitiesDisplayData,
  isHamdastCheraghWidget,
} from '@/modules/profile/utils/cheraghFacilitiesProfile';

/**
 * Public center facilities from Biko (no auth).
 * Empty `{}` when nothing saved — same contract as Biko service.
 */
export async function getDoctorCenterFacilitiesFromBiko(
  userId: string | number,
  centerId: string | number,
  options?: { timeoutMs?: number },
): Promise<CheraghFacilitiesPublicData | null> {
  const uid = String(userId ?? '').trim();
  const cid = String(centerId ?? '').trim();
  if (!uid || !cid) return null;

  try {
    const { data } = await bikoClient.get<CheraghFacilitiesPublicData>(
      `/v1/doctors/${encodeURIComponent(uid)}/centers/${encodeURIComponent(cid)}/facilities`,
      { timeout: options?.timeoutMs ?? 2000 },
    );
    if (!hasCheraghFacilitiesDisplayData(data)) return null;
    return data;
  } catch (error) {
    console.error('Error fetching doctor center facilities from Biko:', error);
    return null;
  }
}
